export default __webpack_public_path__ + "static/media/noun_copy_3992683.dd17ed31.png";